import React from 'react';
import ReactJson from 'react-json-view';
import { useSelector } from 'react-redux';

import Card from '@components/Card';
import Button from '@shared/Button';
import Modal from '@shared/Modal';
import Spinner from '@shared/Spinner';
import ButtonsRow from '@styled/Containers/ButtonsRow';
import P from '@styled/Elements/P';
import UpdateList from '@utils/updateList';

import {getUserRoles} from '@actions/selectors';
import {currentTimeString} from '@src/utils/utils';

export default function SanctionListModal(props) {
  const { list, handleClose, invalidateCache } = props;
  const { active, list_name } = list;
  const [isLoading, setIsLoading] = React.useState(false);
  const [hasChange, setHasChange] = React.useState(false);
  const [inputValue, setInputValue] = React.useState(active);
  const hasNullActive = inputValue !== false && inputValue !== true;

  const handleChangeInput = e => setInputValue(e.target.value);
  const [result, setResult] = React.useState(null);
  const [entity, setEntity] = React.useState(null);

  const apiKey = useSelector(state => state.keys.key);
  const handleCloseAndRefresh = () => window.reload()
  const groups = useSelector(getUserRoles);

  const onChangeActive = e => {
    e.preventDefault();
    const newValue = e.target.value;
    setInputValue(newValue);
    if (newValue !== active) {
      setHasChange(true);
    }
  };
  const onClickUpdateActive = () => {
    const update_ts = currentTimeString();
    setIsLoading(true);
    const onFinish = data => {
      invalidateCache();
      setResult({ status: inputValue });
    };
    UpdateList(apiKey, { ...list, status: inputValue, updated_on: update_ts }, () =>
      setTimeout(onFinish, 1000)
    );
  };

  let hasTogglePermission = groups.includes('Admin')

  if (!hasTogglePermission) {
    return (
      <Modal id='modal' open={list} toggle={handleClose}>
        <Card title={`Update status - ${list_name}`} shadow>
          <div
            style={{
              maxWidth: '600px',
              maxHeight: '600px',
              overflowY: 'scroll',
            }}
          >
            <P>Please request permission to update list status.</P>
            <P>
              <Button onClick={handleClose}>Close</Button>
            </P>
          </div>
        </Card>
      </Modal>
    );
  }

  return (
    <Modal id='modal' open={list} toggle={handleClose}>
      <Card title={`Update status - ${list_name}`} shadow>
        {result && (
          <div
            style={{
              maxWidth: '600px',
              maxHeight: '600px',
              overflowY: 'scroll',
            }}
          >
            <P>
              {list_name} has been updated{' '}
            </P>
            <P>
              <Button onClick={handleClose}>Close</Button>
            </P>
          </div>
        )}
        {!result && (
          <div
            style={{
              maxWidth: '600px',
              maxHeight: '600px',
              overflowY: 'scroll',
            }}
          >
            <P>
              <label>
                Status &nbsp;
                <select
                  onChange={onChangeActive}
                  value={inputValue}
                  id='active-status'
                  name='active-status'
                >
                  <option value={null} selected={hasNullActive} disabled>
                    Select
                  </option>
                  <option value={"Rejected"}>Reject</option>
                  <option value={"Confirmed"}>Confirm</option>
                </select>
              </label>
            </P>
            {isLoading && <Spinner />}
            {!isLoading && hasChange && (
              <ButtonsRow>
                <Button
                  analyticsName='Update active list - Cancel'
                  variant='tertiary'
                  color='black'
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button
                  analyticsName='Update active list - Confirm'
                  variant='primary'
                  color='red'
                  onClick={onClickUpdateActive}
                >
                  {"Update"}
                </Button>
              </ButtonsRow>
            )}
          </div>
        )}
      </Card>
    </Modal>
  );
}
